import { SvgComponent, Banner, constants } from "./sharedImports";

const coreBlue25 = constants.colors.ui.core[25];

const white100 = constants.colors.ui.white["100"];

const fgProfileDark = Banner.foregroundProfiles.dark;

export default (whiteBgColor) => {
  return {
    colors: {
      primary: whiteBgColor ? white100 : coreBlue25,
      foregroundProfile: fgProfileDark,
    },
    SvgComponent,
  };
};
